import { render, staticRenderFns } from "./SHProposalOverview.vue?vue&type=template&id=5a2501e4"
import script from "./SHProposalOverview.vue?vue&type=script&lang=js"
export * from "./SHProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports